"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthInterceptor = void 0;

var _core = require("../../core");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var AuthInterceptor =
/*#__PURE__*/
function (_BaseAuthInterceptor) {
  _inherits(AuthInterceptor, _BaseAuthInterceptor);

  function AuthInterceptor() {
    _classCallCheck(this, AuthInterceptor);

    return _possibleConstructorReturn(this, _getPrototypeOf(AuthInterceptor).apply(this, arguments));
  }

  _createClass(AuthInterceptor, [{
    key: "install",
    value: function install() {
      var _this = this;

      for (var _len = arguments.length, dataServerClients = new Array(_len), _key = 0; _key < _len; _key++) {
        dataServerClients[_key] = arguments[_key];
      }

      dataServerClients.forEach(function (dataService) {
        return dataService.interceptors.request.use(function (config) {
          config.data = config.data || {};
          config.data.Token = _this._tokenProvider.bearerToken;
          return Promise.resolve(config);
        });
      });
    }
  }]);

  return AuthInterceptor;
}(_core.BaseAuthInterceptor);

exports.AuthInterceptor = AuthInterceptor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/core/AuthInterceptor.js
// module id = 249
// module chunks = 0